// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__37k0p","consentsList":"PatientConsents_consentsList__1rAO_","consentsListEmpty":"PatientConsents_consentsListEmpty__1zm5Q"};